module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy1"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm04_copy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("NEW YORK UNIVERSITY PRESS")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("New York and London")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.nyupress.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nyupress.org")])])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("© 2012 by New York University")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("References to Internet websites (URLs) were accurate at the time of writing.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Neither the author nor New York University Press is responsible for URLs")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("that may have expired or changed since the manuscript was prepared.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Hughes, Michael J., 1972-")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Forging Napoleon’s Grande Armée : motivation, military culture, and masculinity in the")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("French army, 1800-1808 / Michael J. Hughes.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("p. cm. — (Warfare and culture series)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 978-0-8147-3748-4 (cl : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 978-0-8147-0827-9 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 978-0-8147-2411-8 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("1. France. Armée. Grande Armée — History.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("2. France. Armée. Grande Armée — Military life.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("3. Soldiers — Attitudes — France — History — 19th century.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("4. Masculinity — France — History — 19th century.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("5. Military morale — France — History — 19th century.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("6. Sociology, Military — France — History — 19th century.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("7. Napoleon I, Emperor of the French, 1769-1821 — Military leadership.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("8. Napoleonic Wars, 1800-1815.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("9. France — History, Military — 1789-1815. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("DC202.1.H84 2012")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("940.2’7420944 — dc23")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("2011050070")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability. We strive to use environmentally responsible suppliers and materials to the greatest extent possible in publishing our books.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fbd7e51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_copy.vue
// module id = 69
// module chunks = 0